"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBackendUrl = void 0;
const axios_1 = require("axios");
const generated_src_1 = require("./generated-src");
const url_mapping_1 = require("./url_mapping");
__exportStar(require("./generated-src"), exports);
const NON_MODIFYING_METHODS = ['GET', 'OPTIONS', 'HEAD'];
class RingRSESchedulingServiceClient extends generated_src_1.DefaultApi {
    constructor(basePath, axiosIntance) {
        super(new generated_src_1.Configuration(), basePath, axiosIntance || axios_1.default.create());
        this.csrfToken = '';
        this.axios.defaults.withCredentials = true;
        this.configureAntiCSRF();
    }
    /**
     * Register an access token fetcher to authenticate API calls.
     * @param getAccessToken is a function instead of string, so that expired token can be updated.
     * @returns axios interceptor id
     */
    registerAccessToken(getAccessToken) {
        return this.axios.interceptors.request.use((config) => {
            config.headers['Authorization'] = getAccessToken();
            return config;
        });
    }
    configureAntiCSRF() {
        this.axios.interceptors.request.use((config) => {
            if (NON_MODIFYING_METHODS.includes(config.method.toUpperCase())) {
                // Request CSRF token
                config.headers['anti-csrftoken-a2z-request'] = 'true';
            }
            else {
                // Send CSRF token
                config.headers['anti-csrftoken-a2z'] = this.csrfToken;
            }
            return config;
        });
        // Receive CSRF token
        this.axios.interceptors.response.use((config) => {
            if (config.headers['anti-csrftoken-a2z']) {
                this.csrfToken = config.headers['anti-csrftoken-a2z'];
            }
            return config;
        });
    }
}
exports.default = RingRSESchedulingServiceClient;
function getBackendUrl(stage, region) {
    return url_mapping_1.BACKEND_URL_MAPPING[stage][region];
}
exports.getBackendUrl = getBackendUrl;
//# sourceMappingURL=index.js.map